/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropkindlabel2Inputs */

const en_dropkindlabel2 = /** @type {(inputs: Dropkindlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind`)
};

const de_dropkindlabel2 = /** @type {(inputs: Dropkindlabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

/**
* | output |
* | --- |
* | "Kind" |
*
* @param {Dropkindlabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropkindlabel2 = /** @type {((inputs?: Dropkindlabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropkindlabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropkindlabel2(inputs)
	return de_dropkindlabel2(inputs)
});
export { dropkindlabel2 as "dropKindLabel" }